const FetaureProductActionType = {
    FEATUREPRODUCT_REQUEST:'FEATUREPRODUCT_REQUEST',
    FEATUREPRODUCT_SUCCESS:'FEATUREPRODUCT_SUCCESS',
    FEATUREPRODUCT_FAIL:'FEATUREPRODUCT_FAIL',


    SINGLE_FEATUREPRODUCT_REQUEST:'SINGLE_FEATUREPRODUCT_REQUEST',
    SINGLE_FEATUREPRODUCT_SUCCESS:'SINGLE_FEATUREPRODUCT_SUCCESS',
    SINGLE_FEATUREPRODUCT_FAIL:'SINGLE_FEATUREPRODUCT_FAIL'
}


export default FetaureProductActionType